module.exports = __webpack_public_path__ + "img/retail.994408c7.png";